import fetch from 'cross-fetch'
import { PROPERTY_INPUT_KEYS } from './PropertyReducers'
import ReactGA from 'react-ga';

import {
    UPDATE_PROPERTY_INPUT,
    UPDATE_PROPERTY_INPUT_BULK,
    REQUEST_PROPERTY_CALC,
    RECEIVE_PROPERTY_CALC,
    UI_TOGGLE_BOOLEAN,
    CHANGE_WIZARD_STEP
} from "./PropertyActionTypes";

import {
    TAX_FROM_PROPERTY
} from "../TaxCalculator/TaxActionTypes";

export const updatePropertyInput = (key, value) => ({
    type: UPDATE_PROPERTY_INPUT,
    key: key,
    value: value
});

export const updatePropertyInputBulk = (values) => ({
    type: UPDATE_PROPERTY_INPUT_BULK,
    values: values
});

export const UIToggleBoolean = (key) => ({
    type: UI_TOGGLE_BOOLEAN,
    key: key
});

export const changeWizardStep = (step) => ({
    type: CHANGE_WIZARD_STEP,
    step: step
});

// We're currently requesting a calculation
function requestPropertyCalc() {
    return {
        type: REQUEST_PROPERTY_CALC
    }
}

// Calc come back from server
export const receivePropertyCalc = (json) => ({
    type: RECEIVE_PROPERTY_CALC,
    calc: json,
    receivedAt: Date.now()
})

export function propertyToTax() {
    console.log('propertyToTax');
    return (dispatch, getState) => {
        var p = getState().property;

        return dispatch({
            type: TAX_FROM_PROPERTY,
            income: p.income,
            allowableExpenses: (p.costsMonthlyManagement + p.costsMonthlyBills + p.costsMonthlyOther) * 12,
            financeCosts: p.interest
        })
    }
};

const numberInputs = [
    'purchasePrice', 'deposit', 'costsRefurbishment', 'income', 'costsMonthlyManagement',
    'costsMonthlyBills', 'costsMonthlyOther', 'interestRate', 'otherBuyingFees',
    'projectionYears', 'profitGoal', 'additionalAnnualInvestment',
    'nonPropertyEarnings', 'nonPropertyDividendIncome'];

// The actual fetching of the calc
function fetchPropertyCalc(property) {

    // Log to analytics
    ReactGA.event({
        category: 'Calculations',
        action: 'Calculation made'
    });

    // Filter the state for only the values in PROPERTY_INPUT_KEYS
    var values = PROPERTY_INPUT_KEYS.reduce(function (o, k) {
        if (numberInputs.includes(k) && isNaN(property[k])) {
            o[k] = 0;
        } else {
            o[k] = property[k];
        }

        return o;
    }, {});

    return dispatch => {
        // TODO:
        var url = 'api/propertycalculation/CalculateWithTax';

        // Tell the app we're starting a request...
        dispatch(requestPropertyCalc())

        return fetch(url, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(
                response => response.json(),
                error => console.log('An error occurred.', error)
            )
            .then(json => dispatch(receivePropertyCalc(json)))
                
           
           
    }
}

// Do we need to fetch?
function fetchPropertyCalcNeeded(property) {
    if (property.isFetching) {
        return false;
    }
    return property.isStale;
}


// As it says on the tin
export function fetchPropertyCalcIfNeeded() {
    console.log('fetchPropertyCalcIfNeeded');
    return (dispatch, getState) => {
        if (fetchPropertyCalcNeeded(getState().property)) {
            return dispatch(fetchPropertyCalc(getState().property));
        } else {
            // Let the calling code know there's nothing to wait for.
            return Promise.resolve()
        }
    }
}


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/PropertyActions.jsx